class CategoryCardItem {
  card: HTMLDivElement;

  constructor(card: HTMLDivElement) {
    this.card = card;

    this.addEventToCard();
  }

  addEventToCard() {
    this.card.addEventListener('mousedown', (event) => this.onCardMouseDown(event));
  }

  getLinkElement(target: HTMLDivElement) {
    return target.querySelector<HTMLAnchorElement>('.arjo-o-category-card__link');
  }

  triggerLinkMouseDown(link: HTMLAnchorElement, event: MouseEvent, triggerClick: boolean = true) {
    const mouseEvent = new MouseEvent('mousedown', {
      bubbles: false,
      cancelable: true,
      view: window,
      button: event.button,
    });
    link.dispatchEvent(mouseEvent);

    triggerClick && link.click();
  }

  onCardMouseDown(event: MouseEvent) {
    const link = this.getLinkElement(event.currentTarget as HTMLDivElement);

    if (!link || event.target === link) return;

    if (event.button === 1) {
      window.open(link.href, '_blank')?.focus();
      this.triggerLinkMouseDown(link, event, false);
    } else {
      this.triggerLinkMouseDown(link, event, true);
    }
  }
}

export { CategoryCardItem };
